import { render, staticRenderFns } from "./tournamentGroupsSlider.vue?vue&type=template&id=7b148298&scoped=true&"
import script from "./tournamentGroupsSlider.vue?vue&type=script&lang=js&"
export * from "./tournamentGroupsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b148298",
  null
  
)

export default component.exports